<ng-container *ngIf="showHyperLink">
    <a
        href="javascript:void(0)"
        class="cc-hyperlink dx-theme-accent-as-text-color"
        [title]="title"
        [ngClass]="cssClass"
        (click)="onHyperlinkClick()"
    >
        <span *ngIf="textLocation === 'left'">{{ displayText }}</span>
        <ng-content></ng-content>
        <span *ngIf="textLocation === 'right'">{{ displayText }}</span>
    </a>
</ng-container>

<ng-container *ngIf="!showHyperLink && !isEmail">
    <span>{{ displayText }}</span>
</ng-container>

<!-- Is Email only for board members -->
<ng-container *ngIf="isEmail">
    <a href="mailto:{{ displayText }}" class="cc-hyperlink dx-theme-accent-as-text-color">{{ displayText }}</a>
</ng-container>
